import { ProjectRole } from '@infura/packages.teams'
import { type V1Project } from '@infura/packages.uks'

import { AllUKSProjects } from 'hooks/useAllProjects'

import { ProjectsGroupedByOwnership, ProjectsGroupedByType } from 'lib/teams/teamsTypes'

interface FilterProjectsByRoleParams {
  projects: Record<string, V1Project>
  roles: Record<string, ProjectRole>
  roleTypes: Array<ProjectRole>
}

export function filterProjectsByRole({ projects, roles, roleTypes }: FilterProjectsByRoleParams): AllUKSProjects {
  const result: AllUKSProjects = { ethereum: [], ipfs: [] }
  Object.values(projects || {}).forEach(project => {
    // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
    if (roleTypes.includes(roles[project.id])) result['ethereum'].push(project)
  })

  return result
}

interface GroupProjectsByTypeParams {
  projects: AllUKSProjects
}

export function groupProjectsByType({ projects }: GroupProjectsByTypeParams): ProjectsGroupedByType {
  return Object.entries(projects).filter(([, arr]) => arr.length)
}

interface GroupProjectsByOwnershipParams {
  projects: AllUKSProjects
  roles: Record<string, ProjectRole>
}

export function groupProjectsByOwnership({
  projects,
  roles
}: GroupProjectsByOwnershipParams): ProjectsGroupedByOwnership {
  const projectsArray = allProjectsToTypedArray({ projects })

  return {
    owned: projectsArray.filter(curProject =>
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      ([ProjectRole.OWNER] as Array<ProjectRole>).includes(roles[curProject.id])
    ),
    shared: projectsArray.filter(curProject =>
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      ([ProjectRole.CONTRIBUTOR, ProjectRole.ADMIN] as Array<ProjectRole>).includes(roles[curProject.id])
    )
  }
}

interface GetProductByProjectIdParams {
  projectId: string
  projects: AllUKSProjects
}

export function getProjectById({ projectId, projects }: GetProductByProjectIdParams): V1Project | undefined {
  const projectsArray = allProjectsToTypedArray({ projects })
  return projectsArray.find(curProject => curProject.id === projectId)
}

interface AllProjectsToTypedArrayParams {
  projects: AllUKSProjects
}

export function allProjectsToTypedArray({
  projects = { ethereum: [], ipfs: [] }
}: AllProjectsToTypedArrayParams): Array<V1Project> {
  return Object.values(projects).flat()
}
